module.exports = __webpack_public_path__ + "static/media/01.0000ff88.jpg";